
import * as qs from "qs";

export default {
  name: "mytemplate",
  data() {
    return {
      classify: [],
      active: 0,
      templateList: [],
      pageNum: 1,
      activeName: 1
    }
  },
  async mounted() {
    await this.getClassify()
  },
  methods: {
    getClassify() {
      this.$ajax.post("/etv/selectAllMouldCategory.json").then(res => {
        if (res.data.code === 0) {
          this.classify = res.data.data
          this.getTemplate()
        }
      })
    },
    getClassifyContent(id) {
      this.active = id
      this.getTemplate()
    },
    getTemplate() {
      this.$ajax.post("/etv/selectH5Mould.json", qs.stringify({
        pageNum: this.pageNum,
        pageSize: 99999,
        resolution: "",
        mouldtypeId: this.classify[this.active].id,
      })).then(res => {
        if (res.data.code === 0) {
          this.templateList = res.data.data.list
          this.count = res.data.data.pages
        }
      })
    },
    getpage(i) {
      this.pageNum = i
      this.getTemplate()
    },
    onEmploy(id) {
      this.$router.push(`/h5Preview/${id}`)
    },
    onError(data) {
      data.sceneMould[0].scThumUrl = "../assets/images/icon_app.png"
    }

  }
}
